export default __webpack_public_path__ + "static/product-card-summary-35caeb829c05ce4334b654098db33d6c.png";